import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import { fieldsMap as categoryFieldMap} from '../trip_categories/fields';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

fieldsMap.set('trip_resource_id', {
	key: 'trip_resource_id',
	name: 'Risorsa',
	inputType: InputTypes.DATASET_AUTOCOMPLETE,
	valueType: ValueTypes.REFERENCE,
	datasetCode: 'trip_resources',
	inputHint: 'Scrivi per cercare una risorsa',
	remoteOptions: {
		limit: 100,
		getLabel(option): any{
			if(!option) return '';
			const label = option.description;
			return label;
		},
		getValue(option): any{
			if(!option) return;
			return option.id;
		},
		getDisplay(option): any{
			if(!option) return '';
			const label = option.description;
			return label;
		}
	},
	defaultValue(datasetContainerService, options, record): any{
		if(!record) return null;
		return record.id;
	}
});

export {fieldsMap};
